<template>
    <!-- <div id="card-info">
        <router-link :to="getUrl(estagioId)">
            <div :class="['col s4 card-icon card gradient-shadow min-height-100 '+corFundo+' '+corTexto]">
                <i class="material-icons mt-5 md-48">{{ icone }}</i>
            </div>
            <div :class="['col s8 card card-no-icon gradient-shadow min-height-100 '+corFundo+' '+corTexto]">
                <div>
                    <div class="col s12">
                        <h3 class="no-margin center-align">{{ numero }}</h3>
                    </div>
                    <div class="col s12 mt-3">
                        <p class="no-margin center-align uppercase">{{ titulo }}</p>
                    </div>
                </div>
            </div>
        </router-link>
    </div> -->
    <div class="card-info">

        <router-link :to="getUrl(estagioId)">
            <section :class="['panel '+corTexto]">
                <div :class="['symbol ' + corFundo]">
                    <i class="material-icons">{{ icone }}</i>
                </div>
                <div class="value no-border">
                    <h3 class="counter">
                        <ICountUp class="" style="font-weight: 400;" :startVal="startVal" :endVal="numero"
                            :decimals="decimals" :duration="duration" :options="options" @ready="onReady" />
                    </h3>
                    <p class="uppercase grey-text text-darken-2" style="line-height: 1.25em;">{{ titulo }}</p>
                </div>
            </section>
        </router-link>

    </div>
</template>

<script>
    import Auth from '@/store/auth';
    import ICountUp from 'vue-countup-v2';
    import { DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDERMASTER } from '@/constants/funcionarioCargo.js';

    export default {
        components: {
            ICountUp
        },
        props: [
            'titulo',
            'numero',
            'icone',
            'corFundo',
            'corTexto',
            'gradiente',
            'mostrarPorcentagem',
            'marcadorAtual',
            'estagioId'
        ],
        data: () => ({
            mostrarPorcentagemFlag: true,
            marcadorAtualFlag: false,
            cargoDono: null,
            cargoGerente: null,
            cargoCorretor: null,
            startVal: 0,
            decimals: 0,
            duration: 2.5,
            options: {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            }
        }),

        created: function () {
            this.usuarioLogadoCargo = Auth.getCargoUsuario();
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;

            if (typeof this.mostrarPorcentagem !== 'undefined') {
                this.mostrarPorcentagemFlag = this.mostrarPorcentagem;
            }

            if (typeof this.marcadorAtual !== 'undefined') {
                this.marcadorAtualFlag = this.marcadorAtual;
            }


        },

        methods: {

            onReady: function (instance, CountUp) {

                const that = this;
                instance.update(that.endVal + 100);

            },

            getUrl(estagioId) {
                return {
                    name: 'gerenciamentoLeads',
                    query: {
                        estados: estagioId
                    }
                }



            },
            checaCargoUsuario(arrayPode) {
                if (this.usuarioLogadoCargo === MASTER) {
                    return true;
                }
                return arrayPode.indexOf(this.usuarioLogadoCargo) !== -1;
            }
        }
    }
</script>

<style scoped>
    /*---------------------
    state overview
-----------------------*/
    .card-info {
        margin-bottom: 20px;
    }
    .center, .center-align {
        text-align: center;
    }

    .symbol,
    .value {
        display: inline-block;
        text-align: center;

    }

    .panel {
        box-shadow: 0 1px 10px 1px rgba(115, 108, 203, .1);
        background-color: #fff;
        border-width: 1px;
        border-style: solid;
    }

    .value {
        float: right;
        text-align: left;
    }

    .value h3,
    .value p {
        margin: 0;
        padding: 0;
    }

    .value h3 {
        font-weight: 300;
    }

    .symbol i {
        font-size: 25px;
        color: #fff;
    }

    .symbol {
        width: 30%;
        padding: 35px 15px;
    }

    .value {
        width: 68%;
        margin-top: 16px;
        border-left: 1px solid;
        padding-left: 6%;
    }

    .value.grayBorder {
        border-color: #eaeaeb;
    }

    .value.whiteBorder {
        border-color: rgba(255, 255, 255, .2);
    }

    .value.no-border {
        border: 0;
    }

    /*----------------------*/

    .green {
        background: #53d192;
        color: #fff;
    }

    .purple {
        background: #a979d1;
        color: #fff;
    }

    .red {
        background: #ff6c60;
        color: #fff;
    }

    .yellow {
        background: #f8d347;
        color: #fff;
    }

    .blue {
        background: #57c8f2;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/CardInfo.vue